import { b as __assign$1 } from '../_tslib-6fadb982.js';
import 'qs';
import axios from 'axios';
import '../_rollupPluginBabelHelpers-e7002f34.js';
import 'jsonp';
import 'mathjs';
import 'moment';
import 'query-string';

var cookie = {
  setCookieV2: function (cookieOption) {
    if (!cookieOption.time) {
      cookieOption.time = 1.5 * 3600;
    }
    var exp = new Date();
    exp.setTime(exp.getTime() + cookieOption.time * 1000);
    cookieOption.value = encodeURIComponent(cookieOption.value);
    var hostname = cookieOption.domain ? cookieOption.domain : '.gaodun.com';
    document.cookie = cookieOption.key + '=' + cookieOption.value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
  },
  setCookie: function (key, value, time) {
    if (!time) {
      time = 3 * 24 * 60 * 60;
    }
    var exp = new Date();
    exp.setTime(exp.getTime() + time * 1000);
    value = encodeURIComponent(value);
    var hostname = '.gaodun.com';
    document.cookie = key + '=' + value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
  },
  getCookie: function (name) {
    var arr;
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    arr = document.cookie.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    } else {
      return '';
    }
  },
  delCookie: function (name) {
    this.setCookie(name, '', -1);
  }
};

var _Promise = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

var _Promise$1 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;
var http = axios.create();

var _Promise$2 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$3 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$4 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise$5 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var _Promise2 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;
var cookie$1 = {
  setCookieV2: function setCookieV2(cookieOption) {
    if (!cookieOption.time) {
      cookieOption.time = 1.5 * 3600;
    }
    var exp = new Date();
    exp.setTime(exp.getTime() + cookieOption.time * 1000);
    cookieOption.value = encodeURIComponent(cookieOption.value);
    var hostname = cookieOption.domain ? cookieOption.domain : '.gaodun.com';
    document.cookie = cookieOption.key + '=' + cookieOption.value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
  },
  setCookie: function setCookie(key, value, time) {
    if (!time) {
      time = 1.5 * 3600;
    }
    var exp = new Date();
    exp.setTime(exp.getTime() + time * 1000);
    value = encodeURIComponent(value);
    var hostname = '.gaodun.com';
    document.cookie = key + '=' + value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
  },
  getCookie: function getCookie(name) {
    var arr;
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    arr = document.cookie.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    } else {
      return '';
    }
  },
  delCookie: function delCookie(name) {
    this.setCookie(name, '', -1);
  }
};
var _Promise$6 = typeof _Promise2 === 'undefined' ? require('es6-promise').Promise : _Promise2;
var _Promise$1$1 = typeof _Promise2 === 'undefined' ? require('es6-promise').Promise : _Promise2;
var _Promise$2$1 = typeof _Promise2 === 'undefined' ? require('es6-promise').Promise : _Promise2;
var _Promise$3$1 = typeof _Promise2 === 'undefined' ? require('es6-promise').Promise : _Promise2;
var _Promise$4$1 = typeof _Promise2 === 'undefined' ? require('es6-promise').Promise : _Promise2;
var GDUSERID = 'GDUSERID';
var USECLIENT = 'useClient';
var User = /** @class */function () {
  function User() {
    this.config = {
      isEmpty: function () {},
      isSameUser: function () {},
      isDifferentUser: function () {},
      useClient: function () {}
    };
    this.initEvent();
    this.listenter = this.listenter.bind(this);
  }
  User.prototype.init = function () {
    if (/\/login/.test(location.pathname)) {
      return;
    }
    var sUserID = sessionStorage.getItem(GDUSERID);
    var cUserID = cookie$1.getCookie(GDUSERID);
    var useClient = cookie$1.getCookie(USECLIENT);
    if (useClient === '0' && this.config.useClient) {
      this.config.useClient();
    }
    if (sUserID === null || cUserID === null) {
      this.config.isEmpty();
    } else if (sUserID === cUserID) {
      this.config.isSameUser();
    } else {
      this.config.isDifferentUser();
    }
  };
  User.prototype.listenter = function () {
    if (!document.hidden) {
      this.init();
    }
  };
  User.prototype.initEvent = function () {
    var _this = this;
    var fn = window.onfocus;
    // 为了解决同一个浏览器，拖出多个窗口的场景，需要使用window.onfocus使用
    window.onfocus = function () {
      if (fn !== null) {
        fn();
      }
      _this.listenter();
    };
  };
  User.prototype.removeListenter = function () {
    window.onfocus = null;
    //document.removeEventListener('visibilitychange', this.listenter)
  };
  User.prototype.setConfig = function (config) {
    this.config = __assign(__assign({}, this.config), config);
    this.init();
  };
  return User;
}();
var user = new User();

var _Promise$7 = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var GDUSERID$1 = 'GDUSERID';
var USECLIENT$1 = 'useClient';
var User$1 = /** @class */ (function () {
    function User() {
        this.handleListener = this.listenter.bind(this);
        this.config = {
            isEmpty: function () { },
            isSameUser: function () { },
            isDifferentUser: function () { },
            useClient: function () { },
        };
        this.initEvent();
        this.listenter = this.listenter.bind(this);
    }
    User.prototype.init = function () {
        if (/\/login/.test(location.pathname)) {
            return;
        }
        var sUserID = sessionStorage.getItem(GDUSERID$1);
        var cUserID = cookie.getCookie(GDUSERID$1);
        var useClient = cookie.getCookie(USECLIENT$1);
        if (useClient === '0' && this.config.useClient) {
            this.config.useClient();
        }
        if (sUserID === null || cUserID === null) {
            this.config.isEmpty();
        }
        else if (sUserID === cUserID) {
            this.config.isSameUser();
        }
        else {
            this.config.isDifferentUser();
        }
    };
    User.prototype.listenter = function () {
        if (!document.hidden) {
            this.init();
        }
    };
    User.prototype.initEvent = function () {
        // let fn: Function | null = window.onfocus;
        // 为了解决同一个浏览器，拖出多个窗口的场景，需要使用window.onfocus使用
        // window.onfocus = () => {
        //     if (fn !== null) {
        //         fn();
        //     }
        //     this.listenter();
        // };
        window.removeEventListener('focus', this.handleListener);
        window.addEventListener('focus', this.handleListener);
    };
    User.prototype.removeListenter = function () {
        window.removeEventListener('focus', this.handleListener);
        // window.onfocus = null;
        //document.removeEventListener('visibilitychange', this.listenter)
    };
    User.prototype.setConfig = function (config) {
        this.config = __assign$1(__assign$1({}, this.config), config);
        this.init();
    };
    return User;
}());
var user$1 = new User$1();

export default user$1;
